import {
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Skeleton } from '@/components/ui/skeleton'

export const RemoveUserFromCompanyDialogFallback = () => {
  return (
    <>
      <AlertDialogHeader>
        <AlertDialogTitle>
          <Skeleton className="h-7 w-28" />
        </AlertDialogTitle>
        <AlertDialogDescription />
        <div>
          <Skeleton className="mb-1 h-3 w-full" />
          <Skeleton className="h-3 w-2/3" />
        </div>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Skeleton className="h-9 w-20" />
        <Skeleton className="h-9 w-23" />
      </AlertDialogFooter>
    </>
  )
}
